import { ContactUsFacadeService } from './contact-us-facade.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'mojo-contact-us',
  templateUrl: './desktop-contact-us.component.html'
})
export class DesktopContactUsComponent implements OnInit {

  @ViewChild('fileUpload', { static: true }) fileUpload: FileUpload;

  canSubmit$ = this.contactUsFacadeService.canSubmit$;

  canCancel$ = this.contactUsFacadeService.canCancel$;
  displayAutocompletes$ = this.contactUsFacadeService.displayAutocompletes$;

  subjects$ = this.contactUsFacadeService.subjects$;

  formGroup: UntypedFormGroup;
  unitSuggestions$ = this.contactUsFacadeService.unitSuggestions$;

  isOnBehalfOfMode$ = this.contactUsFacadeService.isOnBehalfOfMode$;

  form$ = this.contactUsFacadeService.form$;

  units$ = this.contactUsFacadeService.units$;

  showDialog$ = this.contactUsFacadeService.showDialog$;

  callerSuggestions$ = this.contactUsFacadeService.callerSuggestions$;

  constructor(
    private readonly contactUsFacadeService: ContactUsFacadeService) { }

  ngOnInit(): void {
  }

  callerAutoCompleteChange(event: any) {
    this.contactUsFacadeService.callerAutoCompleteChange(event.query);

  }
  unitAutoCompleteChange(event: any) {
    this.contactUsFacadeService.unitAutoCompleteChange(event.query);
    this.contactUsFacadeService.selectUnit(null);
  }

  deselectCaller() {
    this.contactUsFacadeService.selectCaller(null);
  }

  deselectUnit() {
    this.contactUsFacadeService.selectUnit(null);
  }
  /**
   * Send contact us request to API. Display toasts based on whether successful or not
   */
  send(): void {
    this.contactUsFacadeService.submit(this.fileUpload._files);
    this.fileUpload.clear();
  }

  cancel(): void {
    this.contactUsFacadeService.cancel();
    this.fileUpload.clear();
  }

  /**
   * called when a caller is selected from the autocomplete
   */
  handleCallerSelected(data) {
    this.contactUsFacadeService.selectCaller(data.Key);
  }

  /**
   * called when a unit is selected from the autocomplete
   */
  handleUnitSelected(data) {
    this.contactUsFacadeService.selectUnit(data.Key);
  }


}
